"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DowngradeReasonService = void 0;
const operators_1 = require("rxjs/operators");
const http_1 = require("@angular/common/http");
class DowngradeReasonService {
    constructor(http) {
        this.http = http;
        this.downgradeReasonUrl = '/rest-api/fibercart/v1/options/';
    }
    getDowngradeReasonModel(viewModelType, subId) {
        return this.http.get(this.downgradeReasonUrl + viewModelType + '?subscriptionId=' + subId).pipe(operators_1.map((res) => res), operators_1.catchError((error) => {
            const obj = error.message;
            throw obj;
        }));
    }
    updateViewModel(confirmViewModelType, downgradeReasonModel) {
        const headers = new http_1.HttpHeaders().set('Content-Type', 'application/json');
        const bodyContent = downgradeReasonModel;
        return this.http.put(this.downgradeReasonUrl + confirmViewModelType, bodyContent, { headers, responseType: 'text' }).pipe(operators_1.map((res) => res), operators_1.catchError((error) => {
            const obj = error.message;
            throw obj;
        }));
    }
}
exports.DowngradeReasonService = DowngradeReasonService;
//# sourceMappingURL=downgradereason.service.js.map